<div mat-dialog-title class="d-flex">
<h1>{{title}}</h1>
<div class="spacer"></div>
<div class="initials">
    <fa-icon (click)="toggleCamera()" [icon]="faCamera" class="link"></fa-icon> 
</div>
<div class="initials ml-2">
    <fa-icon (click)="uploadFile()" [icon]="faUpload" class="link"></fa-icon> 
</div>
</div>

<div mat-dialog-content class="text-center">
    <input
    type="file"
    class="file-input"
    (change)="onFileSelected($event)"
    #fileInput
    style="display: none"
  />
  <app-camera *ngIf="showCamera" (capturedImage)="showThumb($event)"></app-camera>
  <br/>
  <div class="profile-pic-initials lg">
    <img class="text-center margin-auto" (click)="toggleCamera()" src="./../../../assets/user.png" #webcamImageDisplay alt="webcam image">
  </div>
</div>
<div mat-dialog-actions class="d-flex">
    <button mat-button (click)="onNoClick()">Cancel</button>
    <div class="spacer"></div>
    <button mat-raised-button [disabled]="!webcamImage && !uploadedImage" color="primary" (click)="saveProfilePicture()" cdkFocusInitial>Save</button>
</div>